/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeGrid,
  BaSeGridItem,
  BaSeParagraph,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';
import React from 'react';
import { AlignFilds, CustomFilterWrapperAlign } from '../../candidates-styled';

function MyRecords({
  handleChange,
  filters,
  insideFilter,
  handleFixedFilter,
  fixedFilters,
  setFilter,
}) {
  const isFixed = fixedFilters.myRecords;

  const fixButtonLabel = isFixed ? 'Desafixar' : 'Fixar';
  const fixButtonColor = isFixed ? '#ffa4a4' : '#005EB8';

  const handleChangeoUTSIDEfilter = React.useCallback(
    (key, value) => {
      setFilter((prevFilter) => {
        return {
          ...prevFilter,
          origin: value ? 'MANAGER': '',
          [key]: value,
        };
      });
    },
    [setFilter],
  );

  const returnTitle = React.useCallback(() => {
    return (
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
        Meus cadastros
      </BaSeParagraph>
    );
  }, []);

  if (insideFilter) {
    return (
      <BaSeGrid gap={6}>
        <BaSeGridItem size={5}>{returnTitle()}</BaSeGridItem>

        <BaSeGridItem size={5}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeToggler
              value={filters.myRecords}
               color={!filters.myRecords ? '#939393' : ''}
              onChange={() => {
                if (filters.registeredOnPortal) {
                  handleChange('registeredOnPortal', false);
                }
                handleChange('origin', filters.myRecords ?'MANAGER': '');
                handleChange('myRecords', !filters.myRecords, insideFilter);
              }}
            />
          </div>
        </BaSeGridItem>

        <BaSeGridItem size={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeButton
              value={fixButtonLabel}
              color={fixButtonColor}
              type="tertiary"
              onClick={() => {
                handleFixedFilter('myRecords');
              }}
            />
          </div>
        </BaSeGridItem>
      </BaSeGrid>
    );
  }
  return (
    <CustomFilterWrapperAlign>
      {returnTitle()}
      <AlignFilds>
        <BaSeToggler
          value={filters.myRecords}
          color={!filters.myRecords ? '#939393' : ''}
          onChange={() => {
            if (filters.registeredOnPortal) {
              handleChange('registeredOnPortal', false);
              handleChangeoUTSIDEfilter('origin','');

            }
            handleChangeoUTSIDEfilter('myRecords', !filters.myRecords);
            handleChange('myRecords', !filters.myRecords, insideFilter);
          }}
        />
      </AlignFilds>
    </CustomFilterWrapperAlign>
  );
}

export default MyRecords;
